// extracted by mini-css-extract-plugin
export default {"container":"Photo_container__XBTPQ","photo":"Photo_photo__ebz5+"};